import { Component, ViewChild } from '@angular/core';
import { ActionButtonsComponent } from '../../../components/action-buttons/action-buttons.component';
import { DemoAndProofsComponent as SharedDemoAndProofsComponent } from '../../../components/demo-and-proofs/demo-and-proofs.component';
import { SpacesService } from '../../../services/spaces.service';
import { ModalService } from '../../../services/modal.service';

@Component({
  selector: 'app-demo-and-proofs-page',
  standalone: true,
  imports: [SharedDemoAndProofsComponent, ActionButtonsComponent],
  templateUrl: './demo-and-proofs.component.html',
  styleUrl: './demo-and-proofs.component.scss'
})
export class DemoAndProofsComponent {
  @ViewChild(SharedDemoAndProofsComponent) private readonly demoAndProofs!: SharedDemoAndProofsComponent;

  constructor(
    private readonly spacesService: SpacesService,
    private readonly modalService: ModalService
  ) {}

  resetAll(): void {
    this.demoAndProofs.resetAll();
  }

  openSaveToSpaces(): void {
    this.modalService.openCreateSpaceModal(this.spacesService.getActiveSpace());
  }
}
